import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { CmsLinkComponent, WindowRef } from '@spartacus/core';
import { LinkComponent } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'dp-clickable-link',
  templateUrl: './clickable-link.component.html',
  styleUrls: ['./clickable-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
/* eslint-disable */
export class DpClickableLinkComponent extends LinkComponent {
  readonly #winRef = inject(WindowRef);

  readonly #iconMap: Record<string, string> = {
    UploadFromCSVLink: 'download',
    QuickOrderLink: 'quick-order'
  };

  iconName$: Observable<string | null> = this.data$.pipe(
    map((data?: CmsLinkComponent) => this.#iconMap[data?.uid ?? ''] ?? null)
  );

  linkClicked(javaScript: string): void {
    if (!javaScript) {
      return;
    }
    //TODO A.Z.: Code duplication with footer-navigation-ui.component - should be fixed
    const button = this.#winRef.document.createElement('button');
    button.onclick = (): void => eval(javaScript);
    this.#winRef.document.body.appendChild(button);
    button.click();
    button.remove();
  }
}

/* eslint-enable */
